// D50 — phát hiện tham chiếu ví "mồ côi": giao dịch/khoản định kỳ trỏ tới một ví
// đã bị xoá. Đây là lỗi toàn vẹn dữ liệu thật (số dư theo ví sai), khác với
// category (vốn là free-text lịch sử nên không coi là mồ côi).
//
// DEFAULT_ACCOUNT_ID luôn hợp lệ: state migrate có thể accounts = [] nhưng giao
// dịch vẫn dùng ví mặc định ngầm → không được báo nhầm là mồ côi.

import type { LifeOsState } from "../types";
import { DEFAULT_ACCOUNT_ID } from "../lib/storage";

export type FinanceOrphans = {
  /** Id giao dịch có accountId hoặc toAccountId trỏ tới ví đã xoá. */
  transactionIds: string[];
  /** Id khoản định kỳ có accountId trỏ tới ví đã xoá. */
  recurringIds: string[];
  /** Tổng số bản ghi mồ côi. */
  count: number;
};

/** Tập id ví hợp lệ (gồm ví mặc định ngầm). */
function validAccountIds(state: Pick<LifeOsState, "accounts">): Set<string> {
  return new Set<string>([DEFAULT_ACCOUNT_ID, ...state.accounts.map((a) => a.id)]);
}

/** Liệt kê tham chiếu ví mồ côi trong giao dịch + khoản định kỳ. */
export function findOrphanedFinanceRefs(
  state: Pick<LifeOsState, "accounts" | "transactions" | "recurring">,
): FinanceOrphans {
  const valid = validAccountIds(state);
  const transactionIds = state.transactions
    .filter((t) => (t.accountId && !valid.has(t.accountId)) || (t.toAccountId && !valid.has(t.toAccountId)))
    .map((t) => t.id);
  const recurringIds = state.recurring
    .filter((r) => r.accountId && !valid.has(r.accountId))
    .map((r) => r.id);
  return { transactionIds, recurringIds, count: transactionIds.length + recurringIds.length };
}
